import React, { useState, useEffect } from "react";
import Card from "../components/Card";
import Button from "../components/Button";
import API from "../api/api";
import { useNavigate } from "react-router-dom";

const PERIODOS = {
  dia: 1,
  mes: 30,
  anho: 365,
};

function getDiasAlVencimiento(vencimiento) {
  if (!vencimiento) return 1;
  const hoy = new Date();
  const fechaVenc = new Date(vencimiento);
  const diffMs = Math.abs(
    fechaVenc.setHours(0, 0, 0, 0) - hoy.setHours(0, 0, 0, 0)
  );
  return Math.max(1, Math.ceil(diffMs / (1000 * 60 * 60 * 24)));
}

function calcularOfertaSugerida(monto, vencimiento, porcentaje, periodo) {
  const montoBase = Number(monto || 0);
  const porcentajeBase = Number(porcentaje || 0);

  if (!montoBase || !porcentajeBase || !PERIODOS[periodo]) {
    return {
      dias: getDiasAlVencimiento(vencimiento),
      descuentoPct: 0,
      descuentoMonto: 0,
      montoSugerido: montoBase,
      tasaAnualReferencia: 0,
    };
  }

  const dias = getDiasAlVencimiento(vencimiento);
  const factorPeriodo = dias / PERIODOS[periodo];
  const descuentoPct = (porcentajeBase / 100) * factorPeriodo;
  const descuentoMonto = montoBase * descuentoPct;
  const montoSugerido = Math.max(0, montoBase - descuentoMonto);
  const tasaAnualReferencia =
    periodo === "dia" ? porcentajeBase * 365 :
    periodo === "mes" ? porcentajeBase * 12 :
    porcentajeBase;

  return {
    dias,
    descuentoPct,
    descuentoMonto,
    montoSugerido,
    tasaAnualReferencia,
  };
}

export default function DashboardComprador() {
  const nav = useNavigate();

  const [publicaciones, setPublicaciones] = useState([]);
  const [misOfertas, setMisOfertas] = useState([]);
  const [loadingPublicaciones, setLoadingPublicaciones] = useState(true);
  const [loadingOfertas, setLoadingOfertas] = useState(true);

  const getOperacionesMap = async () => {
    try {
      const resOps = await API.get("/operaciones/mis-movimientos/");
      const opsMap = {};
      (resOps.data || []).forEach((op) => {
        if (op.publicacion?.id) {
          opsMap[String(op.publicacion.id)] = op.id;
        }
      });
      return opsMap;
    } catch (err) {
      console.error("Error obteniendo operaciones:", err);
      return {};
    }
  };

  const getOperacionIdFromStorage = (ofertaId) => {
    try {
      const raw = localStorage.getItem("ofertaOperacionMap");
      if (!raw) return null;
      const map = JSON.parse(raw);
      return map?.[String(ofertaId)] || null;
    } catch (err) {
      console.error("Error leyendo operacionId desde storage:", err);
      return null;
    }
  };

  const fetchPublicaciones = async () => {
    try {
      const res = await API.get("/publicaciones/");
      setPublicaciones(res.data || []);
    } catch (err) {
      console.error("Error cargando publicaciones:", err);
      setPublicaciones([]);
    } finally {
      setLoadingPublicaciones(false);
    }
  };

  const fetchMisOfertas = async () => {
    try {
      const usuarioActual = JSON.parse(localStorage.getItem("usuario") || "null");

      if (!usuarioActual || !usuarioActual.id) {
        console.error("No hay usuario logueado para cargar ofertas");
        setMisOfertas([]);
        setLoadingOfertas(false);
        return;
      }

      console.log("Cargando ofertas para usuario:", usuarioActual);

      const opsMap = await getOperacionesMap();
      const todasLasOfertas = [];

      const resPubs = await API.get("/publicaciones/");
      const pubs = resPubs.data || [];
      const pubsById = {};
      pubs.forEach((pub) => {
        pubsById[String(pub.id)] = pub;
      });

      const pubIdsSet = new Set([
        ...Object.keys(pubsById),
        ...Object.keys(opsMap),
      ]);
      const pubIds = Array.from(pubIdsSet);

      const ofertasPorPub = await Promise.all(
        pubIds.map(async (pubId) => {
          try {
            const resOfertas = await API.get(`/ofertas/publicacion/${pubId}/`);
            const pub = pubsById[pubId] || { id: Number(pubId), titulo: "Publicación #" + pubId };
            return { pub, ofertas: resOfertas.data || [] };
          } catch (err) {
            console.error(`Error obteniendo ofertas de publicaciÃ³n ${pubId}:`, err?.response?.status);
            const pub = pubsById[pubId] || { id: Number(pubId), titulo: "Publicación #" + pubId };
            return { pub, ofertas: [] };
          }
        })
      );

      for (const { pub, ofertas } of ofertasPorPub) {
        const ofertasDelComprador = ofertas.filter((o) => {
          const match = Number(o.comprador) === Number(usuarioActual.id) ||
            o.comprador === parseInt(usuarioActual.id) ||
            o.comprador === String(usuarioActual.id);

          if (match) {
            console.log(`â Oferta encontrada en publicaciÃ³n ${pub.id}:`, o);
          }
          return match;
        });

        for (const oferta of ofertasDelComprador) {
          const operacionId =
            oferta.operacion_id ||
            getOperacionIdFromStorage(oferta.id) ||
            opsMap[String(pub.id)];

          console.log(`Oferta ${oferta.id}: operacion_id=${operacionId}`);

          todasLasOfertas.push({
            ...oferta,
            publicacion: pub,
            operacion_id: operacionId
          });
        }
      }

      console.log("â Mis ofertas cargadas:", todasLasOfertas);


      todasLasOfertas.forEach(oferta => {
        console.log(`Oferta ${oferta.id}: estado=${oferta.estado}, operacion_id=${oferta.operacion_id}`);
      });

      setMisOfertas(todasLasOfertas);
    } catch (err) {
      console.error("Error obteniendo ofertas:", err);
      setMisOfertas([]);
    } finally {
      setLoadingOfertas(false);
    }
  };

  const [formVisible, setFormVisible] = useState({});
  const [montoOferta, setMontoOferta] = useState({});
  const [porcentajeCalculadora, setPorcentajeCalculadora] = useState({});
  const [periodoCalculadora, setPeriodoCalculadora] = useState({});

  const toggleForm = (postId) => {
    setFormVisible(prev => ({
      ...prev,
      [postId]: !prev[postId]
    }));
  };

  const hacerOferta = async (post) => {
    try {
      const monto = montoOferta[post.id];

      if (!monto || Number(monto) <= 0) {
        alert("â ï¸ Ingrese un monto vÃ¡lido mayor a 0");
        return;
      }

      const usuarioString = localStorage.getItem("usuario");
      console.log("=== INICIO ENVIO OFERTA ===");
      console.log("usuarioString RAW:", usuarioString);

      let usuarioActual = null;
      try {
        usuarioActual = usuarioString ? JSON.parse(usuarioString) : null;
      } catch (e) {
        console.error("Error parsing usuario:", e);
        usuarioActual = null;
      }

      console.log("Usuario parseado:", usuarioActual);
      console.log("Tiene ID?:", !!usuarioActual?.id);
      console.log("Monto ingresado:", monto);
      console.log("PublicaciÃ³n:", post);

      if (!usuarioActual || !usuarioActual.id || Object.keys(usuarioActual).length === 0) {
        console.error("â NO HAY USUARIO VÃLIDO EN LOCALSTORAGE");
        console.log("Todos los items del localStorage:");
        console.log("- access:", localStorage.getItem("access"));
        console.log("- refresh:", localStorage.getItem("refresh"));
        console.log("- usuario:", localStorage.getItem("usuario"));

        alert("â ï¸ No estÃ¡s logueado correctamente.\n\nPor favor:\n1. Vuelve a hacer login\n2. O cierra y abre el navegador en modo incÃ³gnito");
        return;
      }

      const payload = {
        publicacion: post.id,
        comprador: usuarioActual.id,
        monto: Number(monto),
      };

      console.log("Payload a enviar:", JSON.stringify(payload, null, 2));

      const response = await API.post("/ofertas/crear/", payload);

      console.log("â RESPUESTA EXITOSA:", response.data);

      alert("â Oferta enviada correctamente!");

      setFormVisible(prev => ({ ...prev, [post.id]: false }));
      setMontoOferta(prev => ({ ...prev, [post.id]: '' }));

      await fetchMisOfertas();

    } catch (err) {
      console.error("â ERROR AL ENVIAR OFERTA:");
      console.error("Error completo:", err);
      console.error("Response:", err?.response);
      console.error("Response data:", err?.response?.data);
      console.error("Response status:", err?.response?.status);

      const errorMessage =
        err?.response?.data?.detail ||
        err?.response?.data?.error ||
        (err?.response?.data ? JSON.stringify(err?.response?.data) : null) ||
        err?.message ||
        "Error desconocido al enviar oferta";

      alert("â Error: " + errorMessage);
    }
  };


  useEffect(() => {
    let mounted = true;

    const checkAndFixUser = async () => {
      const usuarioString = localStorage.getItem("usuario");
      let usuario = null;

      try {
        usuario = usuarioString ? JSON.parse(usuarioString) : null;
      } catch (e) {
        console.error("Error parsing usuario:", e);
      }

      if (!usuario || !usuario.id || Object.keys(usuario).length === 0) {
        console.log("Usuario vaci­o detectado, obteniendo desde /perfil/...");

        try {
          const accessToken = localStorage.getItem("access");

          let userId = null;
          if (accessToken) {
            try {
              const base64Url = accessToken.split('.')[1];
              const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
              const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
              }).join(''));
              const decoded = JSON.parse(jsonPayload);
              userId = decoded.user_id;
              console.log("ID extraido del JWT:", userId);
            } catch (decodeErr) {
              console.error("Error decodificando token:", decodeErr);
            }
          }

          const res = await API.get("/perfil/");
          const userObj = {
            id: userId || res.data.id,
            email: res.data.email,
            nombre: res.data.nombre || res.data.email,
            role: res.data.role,
          };

          if (mounted && userObj.id) {
            localStorage.setItem("usuario", JSON.stringify(userObj));
            console.log("â Usuario corregido en localStorage:", userObj);
          } else if (!userObj.id) {
            console.error("â No se pudo obtener el ID del usuario");
          }
        } catch (err) {
          console.error("â Error obteniendo perfil:", err);
        }
      } else {
        console.log("â Usuario vÃ¡lido en localStorage:", usuario);
      }
    };

    checkAndFixUser();

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    fetchPublicaciones();
    fetchMisOfertas();
    // eslint-disable-next-line
  }, []);


  if (loadingPublicaciones || loadingOfertas)
    return <p className="text-center mt-10 text-primary">Cargando...</p>;

  return (
    <div className="space-y-6">

      {/* -------- Titulo -------- */}
      <h1 className="text-2xl font-bold text-primary">Panel del Comprador</h1>
      <p className="text-slate-600">
        Aqui podras ver publicaciones activas y realizar ofertas.
      </p>

      <h2 className="text-xl font-semibold mt-4">Publicaciones disponibles</h2>

      {publicaciones.length === 0 ? (
        <Card className="p-4 text-center">
          <p className="text-slate-500">No hay publicaciones activas.</p>
        </Card>
      ) : (
        <div className="grid gap-4">
          {publicaciones.map((post) => (
            <Card key={post.id}>
              <div className="flex items-center justify-between">

                {/* Datos */}
                <div>
                  <p className="text-xs uppercase text-slate-500">
                    {post.tipo}
                  </p>
                  <p className="font-semibold text-primary">{post.titulo}</p>

                  <p className="text-sm text-slate-600">
                    Monto: Gs {Number(post.monto).toLocaleString("es-PY")}
                  </p>

                  <p className="text-sm text-slate-600">
                    Vence: {post.vencimiento}
                  </p>

                  {post.descripcion && (
                    <p className="text-sm mt-1">{post.descripcion}</p>
                  )}
                </div>

                <div className="flex flex-col gap-2">
                  <Button onClick={() => toggleForm(post.id)}>
                    {formVisible[post.id] ? "â Cancelar" : "ð° Hacer oferta"}
                  </Button>
                </div>
              </div>

              {formVisible[post.id] && (
                <div className="mt-4 p-4 bg-blue-50 rounded space-y-3 border border-blue-200">
                  <h3 className="font-semibold text-primary">Tu oferta</h3>

                  {(() => {
                    const calculo = calcularOfertaSugerida(
                      post.monto,
                      post.vencimiento,
                      porcentajeCalculadora[post.id],
                      periodoCalculadora[post.id] || "mes"
                    );

                    return (
                      <div className="p-3 bg-white rounded border border-blue-100 space-y-3">
                        <h4 className="font-medium text-primary">
                          Calculadora de oferta
                        </h4>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                          <div>
                            <label className="text-sm font-medium block mb-1">
                              Porcentaje
                            </label>
                            <input
                              type="number"
                              step="0.01"
                              className="border rounded p-2 w-full"
                              placeholder="Ej: 2.5"
                              value={porcentajeCalculadora[post.id] || ""}
                              onChange={(e) =>
                                setPorcentajeCalculadora((prev) => ({
                                  ...prev,
                                  [post.id]: e.target.value,
                                }))
                              }
                            />
                          </div>

                          <div>
                            <label className="text-sm font-medium block mb-1">
                              Período
                            </label>
                            <select
                              className="border rounded p-2 w-full"
                              value={periodoCalculadora[post.id] || "mes"}
                              onChange={(e) =>
                                setPeriodoCalculadora((prev) => ({
                                  ...prev,
                                  [post.id]: e.target.value,
                                }))
                              }
                            >
                              <option value="dia">Por día</option>
                              <option value="mes">Por mes</option>
                              <option value="anho">Por año</option>
                            </select>
                          </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm text-slate-600">
                          <p><b>Días al vencimiento:</b> {calculo.dias}</p>
                          <p><b>Tasa anual de referencia:</b> {calculo.tasaAnualReferencia.toFixed(2)}%</p>
                          <p><b>Descuento estimado:</b> {(calculo.descuentoPct * 100).toFixed(2)}%</p>
                          <p><b>Monto descontado:</b> Gs {Math.round(calculo.descuentoMonto).toLocaleString("es-PY")}</p>
                        </div>

                        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                          <p className="text-sm">
                            <b>Oferta sugerida:</b> Gs {Math.round(calculo.montoSugerido || 0).toLocaleString("es-PY")}
                          </p>
                          <Button
                            className="bg-slate-700 hover:bg-slate-800"
                            onClick={() =>
                              setMontoOferta((prev) => ({
                                ...prev,
                                [post.id]: Math.round(calculo.montoSugerido || 0),
                              }))
                            }
                          >
                            Usar monto calculado
                          </Button>
                        </div>

                        <p className="text-xs text-slate-500">
                          Referencia regulatoria: el tope anual operativo se está manejando en 30%.
                        </p>
                      </div>
                    );
                  })()}

                  <div>
                    <label className="text-sm font-medium block mb-1">
                      Monto ofrecido (Gs) *
                    </label>
                    <input
                      type="number"
                      className="border rounded p-2 w-full"
                      placeholder="Ej: 4700000"
                      value={montoOferta[post.id] || ''}
                      onChange={(e) => setMontoOferta(prev => ({
                        ...prev,
                        [post.id]: e.target.value
                      }))}
                    />
                    <p className="text-xs text-slate-500 mt-1">
                      Ingresa el monto que estÃ¡s dispuesto a pagar por este documento
                    </p>
                  </div>

                  <Button
                    onClick={() => hacerOferta(post)}
                    className="w-full"
                  >
                    â Enviar Oferta
                  </Button>
                </div>
              )}
            </Card>
          ))}
        </div>
      )}

      <h2 className="text-xl font-semibold mt-6">Mis ofertas realizadas</h2>

      {misOfertas.length === 0 ? (
        <Card className="p-4 text-center">
          <p className="text-slate-500">AÃºn no realizaste ofertas.</p>
        </Card>
      ) : (
        <div className="grid gap-4">
          {misOfertas.map((oferta) => (
            <Card key={oferta.id}>
              <div className="flex items-center justify-between">

                <div>
                  <p className="font-semibold text-primary">
                    {oferta.publicacion?.titulo}
                  </p>

                  <p className="text-sm text-slate-600">
                    Monto ofertado:{" "}
                    <b>
                      Gs {Number(oferta.monto).toLocaleString("es-PY")}
                    </b>
                  </p>

                  <p className="text-sm text-slate-600">
                    Estado:{" "}
                    <span
                      className={`font-semibold ${oferta.estado === "pendiente"
                        ? "text-yellow-600"
                        : oferta.estado === "aceptada"
                          ? "text-emerald-600"
                          : "text-red-600"
                        }`}
                    >
                      {oferta.estado?.toUpperCase()}
                    </span>
                  </p>
                </div>

                {/* BotÃ³n para entrar al chat cuando estÃ¡ aceptada */}
                {oferta.estado === "aceptada" && (
                  <Button
                    className="!bg-accent !text-black"
                    disabled={!oferta.operacion_id}
                    onClick={() => {
                      if (!oferta.operacion_id) return;
                      nav("/chat-operacion", {
                        state: { operacionId: oferta.operacion_id },
                      });
                    }}
                  >
                    Ir al chat
                  </Button>
                )}
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
